module.exports = new __parcel__URL__("kitten5.1fe5eed6.png").toString();